export const confirmUpdateProfile = {
  title: 'Внимание',
  content: 'Вы действительно хотите изменить профиль\n',
  okText: 'Сохранить',
  cancelText: 'Отмена',
  className: 'confirm-red',
  okType: 'primary',
  width: 432,
  cancelButtonProps: {
    type: 'primary',
    ghost: true,
  },
};
